import { useState, useEffect } from "react";

// Shared responsive breakpoint hook for phone-width layouts. Matches the 720px
// breakpoint the app shell (Layout) already uses, so views reflow in lockstep
// with the sidebar collapsing to its drawer. Returns true on phone widths and
// updates live on resize / orientation change.
//
// The app is inline-styles only (no CSS media queries), so mobile layout is
// done by branching on this boolean rather than with @media rules.
export default function useIsMobile(maxWidth = 720) {
  const query = "(max-width: " + maxWidth + "px)";
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    // addEventListener is the modern API; addListener is the Safari fallback.
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}
